export default {
  computed: {
    items () {
      return [
        // {
        //   id: 'overview_tour',
        //   title: 'Take a quick tour of user interface',
        //   description: 'We\'ll give you a very quick overview of the AppointmentGuru UI',
        //   instructions: {
        //     video: 'https://www.loom.com/embed/77ccf68ebc7e488aa31237858060d766',
        //     steps: [
        //       {title: 'Watch the video on the left'}
        //     ],
        //     screenshot: null
        //   },
        //   done: false
        // },
        {
          id: 'create_appointment',
          title: 'Create your first appointment',
          description: 'Create an appointment and see how notifications work',
          instructions: {
            video: 'https://www.loom.com/embed/4497e5302f7d4904800a72c665c4ec9e',
            steps: [
              {title: 'Click on the blue plus button in the bottom right of the screen'},
              {
                title: 'Choose "New appointment" (the first icon in the pop-up)',
                items: [
                  'Create a contact with your own details',
                  'Create an appointment for tomorrow just a little past the current time (that way you will get a confirmation and a reminder)',
                  'Make sure that you check the box to send notifications'
                ]
              }
            ],
            results: [
              'How to create an appointment',
              'Add a new client',
              'How automated notifications work'
            ],
            screenshot: null
          },
          done: this.appointments.length > 0
        },
        {
          id: 'add_codes',
          title: 'Add ICD-10 codes to your appointment',
          description: 'In AppointmentGuru appointments are the most important thing. You can store information like ICD-10 codes, notes, product sales, discounts etc. on appointments - these are then reflected on your invoices and on other reports. This means that you can manage you appointments on a day to day, and then easily generate invoices whenever you need to.',
          disabled: this.appointments.length === 0,
          instructions: {
            video: 'https://www.loom.com/embed/a46d5c235d4d4db3850b1adb75d984e0',
            steps: [
              {title: 'Click on the three dots on the appointment below'},
              {title: 'From the menu, click on: "Manage codes"'},
              {title: 'Add some ICD-10 codes in the following dialog'},
              {
                title: '<b>Notes</b>',
                items: [
                  'You can usually bring up this menu wherever you see an appointment in AppointmentGuru',
                  'On the calendar, clicking on an appopintment will give you this menu'
                ]
              }
            ],
            results: [
              'How to add ICD-10 codes to an appointment',
              'How to search our database of codes',
              'How to add multiple ICD-10 codes',
              'How to add extra information like notes and product sales to appointments'
            ]
          },
          done: this.invoices.length > 0
        },
        {
          id: 'create_invoice',
          title: 'Create an invoice',
          description: 'Once you\'ve loaded all the relevant information on an appointment it\'s quick and easy to create an invoice for that appointment',
          disabled: this.appointments.length === 0,
          instructions: {
            video: 'https://www.loom.com/embed/ff3ad08dafbd4908a2f3b32dff1da36e',
            steps: [
              {title: 'Click on the three dots on the appointment below'},
              {title: 'From the menu, click on: "Create invoice"'}
            ],
            results: [
              'How to create an invoice for a single invoice',
              'The various information that you can add to appointments and invoices',
              'How to password protect your invoice',
              'How to add a client\'s medical aid information as you are creating the invoice',
              'How to add a discount on an appointment'
            ]
          },
          done: this.invoices.length > 0
        },
        {
          id: 'send_invoice',
          title: 'Share the invoice',
          description: 'AppointmentGuru makes it easy to share the invoice directly to the client via many different means such as email, sms or whatsapp',
          instructions: {
            video: 'https://www.loom.com/embed/9e95b67ee4154493b7600febe09d7675',
            steps: [
              {title: 'Click on the three dots next to the invoice below'},
              {title: 'From the menu, click on: "Send"'},
              {title: '<b>Note:</b> You can usually bring up this menu wherever you see an invoice in AppointmentGuru'}
            ],
            results: [
              'How to send an invoice an email attachement',
              'How to send an invoice as a link via SMS',
              'Various options for sharing an invoice',
              'Sending an invoice to medical aid'
            ]
          }
        }
        // {
        //   id: 'read_more',
        //   title: 'Read further',
        //   description: 'Links to further tutorials to help you learn more'
        // }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/guides/data/guides/getstarted.js